import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatSelectChange} from "@angular/material/select";
import {AngularFirestore, AngularFirestoreCollection} from "@angular/fire/compat/firestore";
import {environment} from "../../../../../environments/environment";
import firebase from "firebase/compat";
import {ChartOptions} from "../../education-reports/impact-reports/impact-reports.component";
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexPlotOptions,
  ApexYAxis,
  ApexLegend,
  ApexStroke,
  ApexFill,
  ApexTooltip,
  ApexTitleSubtitle,
  ApexGrid,
  ApexMarkers,
  ApexNonAxisChartSeries,
  ApexResponsive,
} from 'ng-apexcharts';
import html2pdf from "html2pdf.js";
import {Observable, Subject} from "rxjs";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {EmployeeService} from "../../../../services/employee.service";
import {Employee} from "../../../../interfaces/Employee";
import {Centre} from "../../../../interfaces/Centres";
import {CentreService} from "../../../../services/centre.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {push} from "@angular/fire/database";
import {MatPaginator} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";
import {map, takeUntil} from "rxjs/operators";
import * as XLSX from "xlsx";
import {FinancialYearService} from "../../../../services/financial-year.service";
import {endOfDay} from '../../../../utils/date-range-format.service';


@Component({
  selector: 'app-intervention-b',
  templateUrl: './intervention-b.component.html',
  styleUrls: ['./intervention-b.component.scss']
})
export class InterventionBComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  @ViewChild('content') content!: ElementRef;
  @Input() showHeading?:boolean=true
  startDate: Date | undefined | null;
  endDate: Date | undefined | null;
  selectedGender: string = "All";
  env = environment.productionMode
  baseRef: AngularFirestoreCollection<any>
  intervention: any;
  mShowChart = false
  mShowInterventionsChart = false
  public interventionsChartOptions!: Partial<ChartOptions>;
  colors: any[] = [{backgroundColor: ["#0b5ba8", "#6114be", "#15dcdc"]}];
  interventionData!: any[];
  selectedIntervention: any[] = []
  _challengesFaced$: Observable<String[]>;
  mChallengesFaced: any[] = []
  selectedChallenges:any [] = [];
  counselorName: any
  employeeData!: Employee[];
  selectedCounselorName: string[]  = []
  _centres$: Observable<Centre[]>;
  interventions!: Observable<String[]>;
  mAllData: any[] = [];
  mFilteredData: any[] = [];
  selectedCentreCode: string[]= []
  selectedCentreName: string[]  = []
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  dataSource: MatTableDataSource<any>
  displayedColumns = ['sr', 'childName', 'intervention', 'challenges','submittedBy']
  public areaChartOptions!: Partial<ChartOptions>;
  public stackedChartOptions!: Partial<ChartOptions>;
  tableStyles = {
    'overflow-x': 'auto',
    'max-width': '100%',
  };
  private centresList: Centre[] = [];

  constructor(
    private mFirestore: AngularFirestore,
    private mDatabase: AngularFireDatabase,
    private userService: EmployeeService,
    private centreService: CentreService,
    private readonly mSnackbar: MatSnackBar,
    private readonly financialYearService: FinancialYearService,
  ) {
    this.baseRef = this.mFirestore.collection<any>(`${this.env.counseling}/allSessions/sessions/`);
    this._challengesFaced$ = this.mDatabase.list<String>('types/Challenges Faced').valueChanges()
    this._challengesFaced$.pipe(takeUntil(this._destroyed$)).subscribe(rs => {
      this.mChallengesFaced = rs
      this.mChallengesFaced.sort()
    })
    this.interventions = this.mDatabase.list<string>('types/Interventions').valueChanges().pipe(
      map(interventions => interventions.sort())
    );
    this._centres$ = this.centreService.getAllCentres().pipe(
      map(centres => [...centres].sort((a, b) => (a.centreName ?? '').trim().localeCompare((b.centreName ?? '').trim())))
    )

    // Store centres list for lookups
    this._centres$.pipe(takeUntil(this._destroyed$)).subscribe(centres => {
      this.centresList = centres;
    });

    this.dataSource = new MatTableDataSource<any>()
    this.dataSource.paginator = this.paginator
  }

  ngOnInit(): void {
    // Pre-fill the date range with the current financial year (search still requires an explicit click)
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;

    // this.baseRef.ref.get().then(res => {
    //   const allInterventions = res.docs.flatMap(x => x.data().interventions || []);
    //
    //   // Use Set to get unique interventions
    //   const uniqueInterventions = [...new Set(allInterventions)];
    //
    //   this.interventionData = uniqueInterventions;
    //   console.log(this.interventionData);
    // });

    this.userService.getUsers().pipe(takeUntil(this._destroyed$)).subscribe(snapshotchanges => {
      this.employeeData = snapshotchanges.map(w => {
        let emp = w.payload.toJSON() as Employee;
        if (w.key != null) {
          emp['id'] = w.key;
        }
        return emp;
      });

      const namesToRemove = ['Shilpa Pahuja', 'Mukti Panchamia'];

      this.counselorName = this.employeeData
        .filter(employee => employee.role === 'Counselling' || employee.role === 'Sr Counselling' || employee.role == 'Psychologist')
        .map(counsellingEmployee => counsellingEmployee.userName)
        .filter(counselorName => !namesToRemove.includes(counselorName)).sort();
    });


  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  getGender($event: MatSelectChange) {
    this.selectedGender = $event.value
    console.log(this.selectedGender)

  }

  searchDataOld() {
    this.mFilteredData = []
    // alert(JSON.stringify(this.selectedCentreCode))
    let challenges: string[] = [];
    let interventions: string[] = [];
    if (this.startDate != null && this.endDate != null) {
      let myQuery: firebase.firestore.Query<any> = this.baseRef.ref;
      myQuery = myQuery.where('date', '>=', this.startDate);
      myQuery = myQuery.where('date', '<=', endOfDay(this.endDate));
      if (this.selectedCentreCode != null) myQuery = myQuery.where('centreCode', 'in', this.selectedCentreCode);
      // if (this.selectedGender != null) myQuery = myQuery.where('gender', 'in', this.selectedGender);

      // if (this.selectedAgeRange != null) myQuery = myQuery.where('age', 'in', this.selectedAgeRange);
      // if (this.selectedHospitalCode != null) myQuery = myQuery.where('hospital', 'in', this.selectedHospitalCode);
      // if (this.selectedChallenges != null) myQuery = myQuery.where('challengesFaced', 'in', this.selectedChallenges);
      // if (this.selectedCounselorName != null) myQuery = myQuery.where('userName', 'in', this.selectedCounselorName);
      myQuery.get().then(res => {
        {
          // alert(res.docs.length)
          this.mAllData = res.docs.map(y => y.data())  //CENTRE AND DATE RANGE
// ['MALE',"FEMALE","THRID","FOURTH"]
          this.mFilteredData = this.mAllData
          console.log(this.mAllData)
          if (this.selectedGender != 'All') {
            // Male
            this.mFilteredData = this.mFilteredData.filter((x) => x.gender == this.selectedGender)
            // c.forEach(c => {
            //   this.mFilteredData.push(c)
            // })

          }
          //
          // if (this.selectedChallenges != null) {
          //     this.selectedChallenges.forEach(it => {
          //         this.mFilteredData = this.mFilteredData.filter((x) => x.challengesFaced.includes(it))
          //         // c.forEach(c => {
          //         //   this.mFilteredData.push(c)
          //         // })
          //
          //     })
          // }
          // if (this.selectedIntervention != null) {
          //     this.selectedIntervention.forEach(it => {
          //         this.mFilteredData = this.mFilteredData.filter((x) => x.interventions == it)
          //         // c.forEach(c => {
          //         //   this.mFilteredData.push(c)
          //         // })
          //     })
          // }

          if (this.selectedCounselorName != null && !this.selectedCounselorName[0] != null) {
            this.selectedCounselorName.forEach((it: any) => {
              this.mFilteredData = this.mFilteredData.filter((x) => x.submittedBy == it)
            })
          }

          this.mFilteredData.forEach(item => {
            if (item.challengesFaced && Array.isArray(item.challengesFaced)) {
              challenges.push(...item.challengesFaced);
            }

            if (item.interventions != null && item.interventions != '') {
              console.log('is intervention')
              interventions.push(item.interventions);
            }
          });
          this.mSnackbar.open(`${this.mFilteredData.length}`, '', {duration: 3000})



          // Count frequency of challenges
          const frequencyMap = new Map<string, number>();

          // Count frequency of interventions

          const interventionsFrequenyMap = new Map<string, number>();
          // this.selectedIntervention.forEach(it=>{
          //
          //   let c  = interventions.filter(x=>x.includes(it))
          // interventions=.push(c)
          // })

          // this.selectedIntervention.forEach(it => {
          //     const filteredData = this.mFilteredData.filter((x) => x.interventions.includes(it));
          //     console.log(this.mFilteredData.length)
          //     // Use a Set to remove duplicates efficiently
          //     const uniqueData = new Set(filteredData.map(item => JSON.stringify(item)));
          //
          //     // Convert uniqueData back to an array of objects
          //     this.mFilteredData = Array.from(uniqueData).map(item => JSON.parse(item));
          // })
          let filteredChallenges: any[] = []
          if (this.selectedChallenges != null && this.selectedChallenges.length>=1) {

            this.selectedChallenges.forEach(it => {
              let c = this.mFilteredData.filter((x) => (x.challengesFaced).includes(it))
              c.forEach(c1 => {
                filteredChallenges.push(c1)
              })
              this.mFilteredData = filteredChallenges
            })
          }

          this.dataSource = new MatTableDataSource( this.mFilteredData)
          this.selectedChallenges.forEach(it => {
            const filteredData = this.mFilteredData.filter((x) => x.challengesFaced.includes(it));
            console.log(this.mFilteredData.length)
            // Use a Set to remove duplicates efficiently
            const uniqueData = new Set(filteredData.map(item => JSON.stringify(item)));

            // Convert uniqueData back to an array of objects
            this.mFilteredData = filteredData
            // alert(this.mFilteredData.length)
          })
          // this.selectedChallenges.forEach(it => {
          //     let unique = challenges.filter((x) => x == it)
          //     filteredChallenges.push(unique)
          // })
          //
          // this.selectedIntervention.forEach(it => {
          //     let unique = interventions.filter((x) => x == it)
          //     filteredInterventions.push(unique)
          // })
          this.mFilteredData.forEach(item => {
            if (item.challengesFaced && Array.isArray(item.challengesFaced)) {
              challenges.push(...item.challengesFaced);
            }

            if (item.intervention != null && item.intervention != '') {
              console.log('is State'+item.state)
              interventions.push(item.intervention);
            }
          });

          if (this.selectedChallenges != null && this.selectedChallenges.length>=1) {

            this.selectedChallenges.forEach(it => {
              let c = this.mFilteredData.filter((x) => (x.challengesFaced).includes(it))
              c.forEach(c1 => {
                filteredChallenges.push(c1)
              })
              this.mFilteredData = filteredChallenges
            })
          }



          challenges.forEach(challenge => {
            frequencyMap.set(challenge, (frequencyMap.get(challenge) || 0) + 1);
          });

          interventions.forEach(intervention => {
            console.log('interventions', intervention)
            interventionsFrequenyMap.set(intervention, (interventionsFrequenyMap.get(intervention) || 0) + 1);
          });

          // Extract Interventions labels and label counts

          let mInterventionLabels: string[] = Array.from(interventionsFrequenyMap.keys());

          let mInterventionLabelCounts: number[] = Array.from(interventionsFrequenyMap.values());

          // Extract Challenges labels and label counts

          let mChallengesLabels: string[] = Array.from(frequencyMap.keys());

          let mChallengesLabelCounts: number[] = Array.from(frequencyMap.values());
          // Filter challenges labels and label counts based on selected challenges
          let filteredLabels: string[] = [];
          let filteredLabelCounts: number[] = [];

          if(this.selectedIntervention.length>=1){
            // Loop through each challenge label and count
            for (let i = 0; i < mInterventionLabels.length; i++) {
              const interventionLabel = mInterventionLabels[i];
              const interventionLabelCount = mInterventionLabelCounts[i];

              // Check if the challenge is in selectedChallenges
              if (this.selectedIntervention.includes(interventionLabel)) {
                // Add the challenge label and count to filtered arrays
                filteredLabels.push(interventionLabel);
                filteredLabelCounts.push(interventionLabelCount);
              }

            }
            mInterventionLabels=filteredLabels
            mInterventionLabelCounts =filteredLabelCounts
          }

          if(this.selectedChallenges.length>=1){
            // Loop through each challenge label and count
            for (let i = 0; i < mChallengesLabels.length; i++) {
              const challengesLabels = mChallengesLabels[i];
              const challengesLabelCount = mChallengesLabelCounts[i];

              // Check if the challenge is in selectedChallenges
              if (this.selectedIntervention.includes(challengesLabels)) {
                // Add the challenge label and count to filtered arrays
                filteredLabels.push(challengesLabels);
                filteredLabelCounts.push(challengesLabelCount);
              }

            }

            mChallengesLabels=filteredLabels
            mChallengesLabelCounts =filteredLabelCounts
          }

          // Display extracted data for debugging

          // console.log('CHALLENGES LABELS:', mChallengesLabels);
          //
          // console.log('CHALLENGES LABEL COUNT:', mChallengesLabelCounts);
          //
          // console.log('Intervention ', interventions);
          //
          // console.log('INTERVENTION LABELS:', mInterventionLabels);
          //
          // console.log('INTERVENTION LABEL COUNT:', mInterventionLabelCounts);


          this.showInterventionsChart(mInterventionLabels, mInterventionLabelCounts)
          // this.showChallengesChart(mChallengesLabels, mChallengesLabelCounts)
        }
      })

    } else {
      this.mSnackbar.open('Please select a proper date range first', '', {
        panelClass: 'error',
        duration: 3000
      })
    }
  }
  searchDataMy() {
    if (!this.startDate || !this.endDate) {
      this.mSnackbar.open('Please select a proper date range first', '', { panelClass: 'error', duration: 3000 });
      return;
    }

    this.mFilteredData = [];
    let challenges: string[] = [];
    let interventions: string[] = [];
    let filteredChallenges: any[] = []
    let filteredInterventions: any[] = []

    let myQuery: firebase.firestore.Query<any> = this.baseRef.ref
      .where('date', '>=', this.startDate)
      .where('date', '<=', endOfDay(this.endDate));

    if (this.selectedCentreCode) {
      myQuery = myQuery.where('centreCode', 'in', this.selectedCentreCode);
    }

    myQuery.get().then(res => {
      this.mAllData = res.docs.map(y => y.data());

      this.mFilteredData = this.mAllData.filter(x => this.selectedGender === 'All' || x.gender === this.selectedGender);

      if (this.selectedCounselorName && this.selectedCounselorName.length) {
        this.selectedCounselorName.forEach((it: any) => {
          this.mFilteredData = this.mFilteredData.filter(x => x.submittedBy === it);
        });
      }
      if (this.selectedChallenges != null && this.selectedChallenges[0] != "All") {

        this.selectedChallenges.forEach(it => {
          let c = this.mFilteredData.filter((x) => (x.challengesFaced).includes(it))
          c.forEach(c1 => {
            filteredChallenges.push(c1)
          })
          this.mFilteredData = filteredChallenges
        })
      }

      if (this.selectedIntervention != null && this.selectedIntervention[0] != "All") {
        this.selectedIntervention.forEach(it => {

          let c = this.mFilteredData.filter((x) =>  (x.interventions).includes(it))

          c.forEach(c1 => {
            filteredInterventions.push(c1)
            console.log('filtered Intervention '+ c1)
          })
          this.mFilteredData = filteredInterventions
        })
      }


      //Add to graph
      this.mFilteredData.forEach(item => {
        if (item.challengesFaced && Array.isArray(item.challengesFaced)) {
          challenges.push(...item.challengesFaced);
        }
        if (item.interventions && Array.isArray(item.interventions)) {
          interventions.push(...item.interventions);
        }
      });
      this.dataSource =new MatTableDataSource<any>(this.mFilteredData)
      const frequencyMap = new Map<string, number>();
      const interventionsFrequencyMap = new Map<string, number>();

      challenges.forEach(challenge => {
        frequencyMap.set(challenge, (frequencyMap.get(challenge) || 0) + 1);
      });
      console.log('intervetions',interventions.length)
      interventions.forEach(intervention => {
        interventionsFrequencyMap.set(intervention, (interventionsFrequencyMap.get(intervention) || 0) + 1);
      });

      const mChallengesLabels: string[] = Array.from(frequencyMap.keys());
      const mChallengesLabelCounts: number[] = Array.from(frequencyMap.values());

      const mInterventionLabels: string[] = Array.from(interventionsFrequencyMap.keys());
      const mInterventionLabelCounts: number[] = Array.from(interventionsFrequencyMap.values());

      this.showInterventionsChart(mInterventionLabels, mInterventionLabelCounts);
      // this.showChallengesChart(mChallengesLabels, mChallengesLabelCounts);
    });
  }
  searchData() {
    this.mFilteredData = []; // Clear table data
    this.clearCharts(); // Clear chart data

    if (!this.startDate || !this.endDate) {
      this.mSnackbar.open('Please select a proper date range first', '', {
        panelClass: 'error',
        duration: 3000
      });
      return;
    }

    let myQuery: firebase.firestore.Query<any> = this.baseRef.ref;
    myQuery = myQuery.where('date', '>=', this.startDate).where('date', '<=', endOfDay(this.endDate));

    console.log('in searchData selectedCentreCode', this.selectedCentreCode);
    if (this.selectedCentreCode != null && this.selectedCentreCode.length >= 1) {
      myQuery = myQuery.where('centreCode', 'in', this.selectedCentreCode);
    }

    myQuery.get().then(res => {
      this.mSnackbar.open(`Docs: ${res.docs.length}`, '', { duration: 3000 });
      const docs = res.docs;
      const docsData = docs.map(doc => doc.data());

      // Handle missing states with reduced iterations
      for (let i = 0; i < docsData.length; i++) {
        docsData[i].state = docsData[i].state ?? 'NA';
      }

      this.mAllData = docsData;
      this.mFilteredData = [...this.mAllData];

      if (this.mFilteredData.length >= 1) this.applyFilters();
      if (this.mFilteredData.length >= 1) this.processChartData();

      this.dataSource = new MatTableDataSource(this.mFilteredData);
      this.dataSource.paginator = this.paginator;

      this.mSnackbar.open(`Docs: ${this.mFilteredData.length}`, '', { duration: 3000 });
    });
  }

  Clear() {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;
    this.selectedCentreCode = [];
    this.selectedGender = 'All';
    this.selectedChallenges = [];
    this.selectedIntervention = [];
    this.selectedCounselorName = [];
    // this.searchText = '';
  }

  private clearCharts() {
    // Assuming you're using some charting library, this is where you clear the charts
    // this.showChallengesChart([], []);  // Clear the Challenges chart
    this.showInterventionsChart([], []);  // Clear the Interventions chart
    // this.showStatesChart([], []);  // Clear the States chart if needed
  }

  private applyFilters() {
    // Reset the filtered data to the full dataset
    this.mFilteredData = [...this.mAllData];

    // Filter by gender if necessary
    if (this.selectedGender !== 'All') {
      this.mFilteredData = this.mFilteredData.filter(x => x.gender === this.selectedGender);
    }

    // Filter by challenges if necessary
    if (this.selectedChallenges.length > 0) {
      this.mFilteredData = this.mFilteredData.filter((x) =>
        this.selectedChallenges.some((challenge) => x.challengesFaced.includes(challenge))
      );
    }

    // Filter by counselor name if necessary
    if (this.selectedCounselorName.length > 0) {
      this.mFilteredData = this.mFilteredData.filter(x => this.selectedCounselorName.includes(x.submittedBy));
    }

    // Filter by interventions if necessary
    // if (this.selectedIntervention.length > 0) {
    //   this.mFilteredData = this.mFilteredData.filter((x) =>
    //     this.selectedIntervention.some((intervention) => x.interventions.includes(intervention))
    //   );
    // }

    // Update the table with the filtered data
    this.dataSource = new MatTableDataSource(this.mFilteredData);
    this.dataSource.paginator = this.paginator;
  }


  downloadExcel() {
    if (!this.dataSource || !this.dataSource.data || this.dataSource.data.length === 0) {
      this.mSnackbar.open('No data available to download', '', {
        duration: 2000
      });
      return;
    }

    const exportData = this.dataSource.data.map((item: any, index: number) => ({
      'Sr No': index + 1,
      'Child Name': item.childName || '',
      'Session Date': item.date?.toDate
        ? item.date.toDate().toLocaleDateString()
        : '',
      'Session Type': item.type || '',
      'Intervention': Array.isArray(item.interventions)
        ? item.interventions.join(', ')
        : item.interventions || '',
      'Challenges Faced': Array.isArray(item.challengesFaced)
        ? item.challengesFaced.join(', ')
        : item.challengesFaced || '',
      'Counsellor Name': item.submittedBy || '',
      'Centre Name': item.centreName || '',
      'Gender': item.gender || '',
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Intervention Report');

    const fileName = `Intervention_Report_${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(workbook, fileName);

    this.mSnackbar.open('Excel downloaded successfully', '', {
      duration: 2000
    });
  }

  private processChartData() {
    const challengesMap = new Map<string, number>();
    const interventionsMap = new Map<string, number>();

    // Iterate over the filtered data
    this.mFilteredData.forEach(item => {
      // Count challenges
      if (item.challengesFaced && Array.isArray(item.challengesFaced)) {
        item.challengesFaced.forEach((challenge: string) => {
          challengesMap.set(challenge, (challengesMap.get(challenge) || 0) + 1);
        });
      }

      // Count interventions
      if (item.interventions && Array.isArray(item.interventions)) {
        item.interventions.forEach((intervention: string) => {
          interventionsMap.set(intervention, (interventionsMap.get(intervention) || 0) + 1);
        });
      }
    });

    // Convert the challenge and intervention maps to arrays for charting
    const mChallengesLabels = Array.from(challengesMap.keys());
    const mChallengesLabelCounts = Array.from(challengesMap.values());

    const mInterventionLabels = Array.from(interventionsMap.keys());
    const mInterventionLabelCounts = Array.from(interventionsMap.values());

    // Show the updated charts
    // this.showChallengesChart(mChallengesLabels, mChallengesLabelCounts);
    this.showChallengesChart(this.mFilteredData);
    this.showInterventionsChart(mInterventionLabels, mInterventionLabelCounts);

    // Optionally update table data
    this.dataSource = new MatTableDataSource<any>(this.mFilteredData);
  }

  // Helper function to count occurrences of each item
  private countFrequency(arr: string[]): Map<string, number> {
    const frequencyMap = new Map<string, number>();
    arr.forEach(item => {
      frequencyMap.set(item, (frequencyMap.get(item) || 0) + 1);
    });
    return frequencyMap;
  }

  private showInterventionsChart(mInterventionLabels: string[], mInterventionLabelCounts: number[]) {
    // Assuming mChallengesLabelCharts is an array of counts for each challenge
    const interventionsMap = new Map<string, number>();
    mInterventionLabels.forEach((label, index) => {
      interventionsMap.set(label, mInterventionLabelCounts[index]);
    });

    // Filtered data arrays
    let filteredLabels: string[] = [];
    let filteredChartData: number[] = [];

    if (mInterventionLabels.length > 0) {
      if (this.selectedIntervention.length > 0) {
        // Loop over selectedChallenges and get the corresponding chart data
        this.selectedIntervention.forEach(it => {
          if (interventionsMap.has(it)) {
            filteredLabels.push(it); // Add the challenge to filtered labels
            filteredChartData.push(interventionsMap.get(it) as number); // Add the corresponding chart data
          }
        });
      } else {
        // alert('into')
        filteredChartData = mInterventionLabelCounts
        filteredLabels = mInterventionLabels
      }
    }
    this.interventionsChartOptions = {
      series: [
        {
          name: 'Count',
          data: filteredChartData,
        }
      ],
      chart: {
        height: 450,
        type: 'bar',
        toolbar: {
          show: true,
        },
        foreColor: '#9aa0ac',
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          distributed: true, // Ensure bars are colored individually
        }
      },
      colors: ['#4379F2', '#EF5A6F', '#387F39', '#6439FF', '#FF885B', '#48CFCB', '#FABC3F', '#A28B55', '#921A40',
        '#85f76c', '#8E44AD', '#1F8A70', '#b58561', '#2C3E50', '#E74C3C', '#9B59B6', '#3498DB', '#F1C40F',
        '#16A085', '#D35400', '#1a628f', '#C0392B', '#27AE60', '#BDC3C7', '#FF6347', '#FF1493', '#6A5ACD', '#FFD700'],
      dataLabels: {
        enabled: true,
      },
      stroke: {
        curve: 'stepline',
      },
      xaxis: {
        type: 'category',
        categories: filteredLabels,
        // categories: [
        //     '2018-09-19',
        //     '2018-09-20',
        //     '2018-09-21',
        //     '2018-09-22',
        //     '2018-09-23',
        //     '2018-09-24',
        //     '2018-09-25',
        // ],
      },
      legend: {
        show: true,
        showForSingleSeries: true, // Always show the legend even for one series
        position: 'top',
        horizontalAlign: 'center',
        offsetX: 0,
        offsetY: 0,
      },
      grid: {
        show: true,
        borderColor: '#9aa0ac',
        strokeDashArray: 1,
      },
      tooltip: {
        theme: 'dark',
        marker: {
          show: true,
        },
        x: {
          show: true,
        },
      },
    };
    this.mShowInterventionsChart = true
  }

  private showStackedChart(mFilteredData: any[], mChallengesLabels: string[], mChallengesLabelCounts: number[]) {
    // Initialize objects to store counts for each state and centre combination
    const stateCentreCounts: { [key: string]: { [key: string]: number } } = {};

    // Iterate through mFilteredData to count occurrences of each state for each centre
    mFilteredData.forEach(item => {
      if (item.state==null) item.state=='NA'
      const state = item.state||'NA';
      const centre = item.centreName;

      // Ensure that the state and centre properties exist
      if (state && centre) {
        if (!stateCentreCounts[state]) {
          stateCentreCounts[state] = {};
        }
        if (!stateCentreCounts[state][centre]) {
          stateCentreCounts[state][centre] = 0;
        }
        stateCentreCounts[state][centre]++;
      }
    });

    // Extract unique centres and states
    const centres = Object.keys(stateCentreCounts[Object.keys(stateCentreCounts)[0]]);
    const states = Object.keys(stateCentreCounts);
    const colorPalette = this.generateColorPalette(centres.length);
    // Prepare data for the chart
    const series :any[]= [];
    centres.forEach((centre,i:number) => {
      const data:any[] = [];
      states.forEach((state) => {
        data.push(stateCentreCounts[state][centre] || 0);
      });
      series.push({ name: centre, data: data ,color: colorPalette[i]});
    });

    // Generate color palette dynamically based on the number of unique centres
    // Configure chart options
    this.stackedChartOptions = {
      series: series,
      chart: {
        height: 350,
        type: 'bar',
        stacked: true,
        toolbar: {
          show: true,
        },
        foreColor: '#9aa0ac',
      },
      colors: ['#0e28a6', '#e83108'],
      dataLabels: {
        enabled: true,
      },
      stroke: {
        curve: 'smooth',
      },
      xaxis: {
        type: 'category',
        categories: mChallengesLabels,
      },
      legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'center',
        offsetX: 0,
        offsetY: 0,
      },
      grid: {
        show: true,
        borderColor: '#9aa0ac',
        strokeDashArray: 1,
      },
      tooltip: {
        theme: 'dark',
        marker: {
          show: true,
        },
        x: {
          show: true,
        },
      },
    };

  }

  private showChallengesChart(mFilteredData: { challengesFaced?: string; centreName: string }[]) {
    // 1. Initialize the object to count challenges per centre
    const challengesCentreCounts: Record<string, Record<string, number>> = {};

    // 2. Check if any challenges are selected
    if (this.selectedChallenges.length === 0) {
      // If no challenges are selected, count all challenges
      mFilteredData.forEach(item => {
        const { challengesFaced = 'NA', centreName } = item;
        if (challengesFaced && centreName) {
          if (Array.isArray(challengesFaced)) {
            challengesFaced.forEach((challenge: string) => {
              challengesCentreCounts[challenge] = challengesCentreCounts[challenge] || {};
              challengesCentreCounts[challenge][centreName] = (challengesCentreCounts[challenge][centreName] || 0) + 1;
            });
          } else {
            challengesCentreCounts[challengesFaced] = challengesCentreCounts[challengesFaced] || {};
            challengesCentreCounts[challengesFaced][centreName] = (challengesCentreCounts[challengesFaced][centreName] || 0) + 1;
          }
        }
      });
    } else {
      // If specific challenges are selected, filter and count only those challenges
      mFilteredData.forEach(item => {
        const { challengesFaced = 'NA', centreName } = item;
        if (challengesFaced && centreName) {
          if (Array.isArray(challengesFaced)) {
            challengesFaced.forEach((challenge: string) => {
              if (this.selectedChallenges.includes(challenge)) {
                challengesCentreCounts[challenge] = challengesCentreCounts[challenge] || {};
                challengesCentreCounts[challenge][centreName] = (challengesCentreCounts[challenge][centreName] || 0) + 1;
              }
            });
          } else if (this.selectedChallenges.includes(challengesFaced)) {
            challengesCentreCounts[challengesFaced] = challengesCentreCounts[challengesFaced] || {};
            challengesCentreCounts[challengesFaced][centreName] = (challengesCentreCounts[challengesFaced][centreName] || 0) + 1;
          }
        }
      });
    }

    // 3. Determine which challenges to display (all challenges if none are selected)
    const challenges = this.selectedChallenges.length === 0
      ? Object.keys(challengesCentreCounts)  // All challenges if none are selected
      : this.selectedChallenges;  // Only selected challenges if any are selected

    // 4. Collect all unique centres from the data using a Set
    const allCentres = new Set<string>();
    mFilteredData.forEach(item => {
      if (item.centreName) {
        allCentres.add(item.centreName);
      }
    });

    // 5. Generate a color palette for multicolor centers
    const colorPalette = this.generateColorPalette(allCentres.size); // Change to the number of centers

    // 6. Create series data for each unique centre
    const series: { name: string; data: number[]; color: string }[] = [];

    for (const centre of allCentres) {
      const data = challenges.map(challenge => challengesCentreCounts[challenge]?.[centre] ?? 0);  // Collect data for each challenge (all or selected)

      series.push({
        name: centre,  // Name of the center for the legend
        data,          // Data for the count of the challenge
        color: colorPalette[series.length % colorPalette.length]  // Assign a unique color for each center
      });
    }
    // console.log('series', series)
    // Configure chart options
    this.areaChartOptions = {
      series: series,
      chart: {
        height: 350,
        type: 'bar',
        stacked: true,
        toolbar: {
          show: false,
        },
        foreColor: '#9aa0ac',
      },
      colors: series.map(s => s.color),
      plotOptions: {
        bar: {
          horizontal: false,  // Vertical stacked bars
        },
      },
      dataLabels: {
        enabled: true,
      },
      stroke: {
        curve: 'smooth',
      },
      xaxis: {
        type: 'category',
        categories: challenges,
      },
      legend: {
        show: true,
        showForSingleSeries: true, // Always show the legend even for one series
        position: 'top',
        horizontalAlign: 'center',
        offsetX: 0,
        offsetY: 0,
      },
      grid: {
        show: true,
        borderColor: '#9aa0ac',
        strokeDashArray: 1,
      },
      tooltip: {
        theme: 'dark',
        marker: {
          show: true,
        },
        x: {
          show: true,
        },
      },
    };

    this.mShowChart = true;
  }

  printDoc() {
    const content = this.content.nativeElement;
    // Configure options for the PDF
    const options = {
      margin: 10,
      filename: `Challenges Report.pdf`,
      image: {type: 'jpeg', quality: 0.98},
      html2canvas: {scale: 1},
      jsPDF: {unit: 'mm', format: 'a4', orientation: 'portrait'}
    };

    // Use html2pdf.js to generate the PDF
    html2pdf()
      .from(content)
      .set(options)
      .save();

  }

  getSelectedChallenges($event: MatSelectChange) {
    this.selectedChallenges = $event.value
    console.log(this.selectedChallenges)
  }


  getCounselorName($event: any) {
    this.selectedCounselorName = $event.value
    console.log(this.selectedCounselorName)

  }

  setSelectedCentreCode($event: MatSelectChange) {
    let centres = $event.value
    this.selectedCentreCode = []
    this.selectedCentreName = []
    centres.forEach((c: Centre) => {
      if (this.selectedCentreName != null) this.selectedCentreName.push(c.centreName)
      if (this.selectedCentreCode != null) this.selectedCentreCode.push(c.centreCode)
      // alert(JSON.stringify(this.selectedCentreCode))
    })
  }

  getSelectedInterventions($event: MatSelectChange) {
    this.selectedIntervention = $event.value

  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  // Clear() {
  //   this.startDate = null
  //   this.endDate = null
  //   this.selectedCentreCode =null
  //
  // }
  private generateColorPalette(numColors: number): string[] {
    // Define a set of predefined colors or generate them dynamically
    const predefinedColors = ['#0e28a6', '#e83108', '#0abf3e', '#e8910a', '#6a0abf', '#0abfbf', '#bf0a4a'];
    const colorPalette: string[] = [];

    // If the number of colors required exceeds the predefined set, generate additional colors
    for (let i = 0; i < numColors; i++) {
      colorPalette.push(predefinedColors[i % predefinedColors.length]);
    }

    return colorPalette;
  }

  // Helper method to get centre name by code
  getCentreNameByCode(centreCode: string): string {
    const centre = this.centresList.find(c => c.centreCode === centreCode);
    return centre ? centre.centreName : centreCode;
  }

// Helper method to get selected centre names for display
  getSelectedCentreNamesDisplay(): string {
    if (!this.selectedCentreCode || this.selectedCentreCode.length === 0) {
      return '';
    }
    return this.selectedCentreCode
      .map(code => this.getCentreNameByCode(code))
      .join(', ');
  }

  getSelectedChallengesDisplay(): string {
    if (!this.selectedChallenges || this.selectedChallenges.length === 0) {
      return '';
    }
    return this.selectedChallenges.join(', ');
  }

// Helper method to get selected interventions for display
  getSelectedInterventionsDisplay(): string {
    if (!this.selectedIntervention || this.selectedIntervention.length === 0) {
      return '';
    }
    return this.selectedIntervention.join(', ');
  }

  getSelectedCounselorNamesDisplay(): string {
    if (!this.selectedCounselorName || this.selectedCounselorName.length === 0) {
      return '';
    }
    return this.selectedCounselorName.join(', ');
  }

}
